import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/products', label: 'Products' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm border-b border-gray-100' : 'bg-white'
      }`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center transition-opacity duration-250 hover:opacity-80" data-testid="logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_farm-water-solutions/artifacts/rav4m0qb_Gemini_Generated_Image_4aakp34aakp34aak.png"
              alt="Ganga Irrigation"
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[#1F2937] hover:text-[#6ABD45] font-medium transition-all duration-250 relative group ${
                  location.pathname === link.path ? 'text-[#6ABD45]' : ''
                }`}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-2 left-0 w-full h-0.5 bg-[#6ABD45] transform transition-transform duration-250 origin-left ${
                    location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`}
                ></span>
              </Link>
            ))}
          </nav>

          {/* WhatsApp Button - Desktop */}
          <a
            href="https://wa.me/919448650161"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md font-semibold transition-all duration-250 hover:bg-[#20BA5A] hover:shadow-md hover:-translate-y-0.5"
            data-testid="header-whatsapp-button"
          >
            <FaWhatsapp className="text-lg" />
            <span>+91 9448650161</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#2E368F] text-2xl transition-transform duration-250 hover:scale-110"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100" data-testid="mobile-menu">
          <nav className="px-6 py-8 space-y-1 max-w-7xl mx-auto">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-[#1F2937] hover:text-[#6ABD45] hover:bg-gray-50 font-medium py-3 px-4 rounded-md transition-all duration-250 ${
                  location.pathname === link.path ? 'text-[#6ABD45] bg-gray-50' : ''
                }`}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://wa.me/919448650161"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md font-semibold mt-4 transition-all duration-250 hover:bg-[#20BA5A]"
              data-testid="mobile-whatsapp-button"
            >
              <FaWhatsapp className="text-lg" />
              <span>+91 9448650161</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
